<template>
  <a-modal
    :title="type == 'edit' ? '编辑客户' : '新建客户'"
    okText="保存"
    @ok="save"
    v-model="visible"
    :width="650"
  >
    <a-form :form="form">
      <a-spin :spinning="loading" size="large">
        <h3>公司信息</h3>
        <a-row :gutter="30">
          <a-col span="12">
            <a-form-item label="公司实名">
              <a-select
                v-decorator="[
                  'name',
                  { rules: [{ required: true, message: '请填写所属公司' }] }
                ]"
                showSearch
                placeholder="请输入公司实名"
                style="width: 100%"
                :defaultActiveFirstOption="false"
                :showArrow="false"
                :filterOption="false"
                @search="handleSearchC"
                :notFoundContent="null"
              >
                <a-select-option
                  v-for="(item, index) in dataCompany"
                  :key="index"
                  :value="item.name"
                  style="zIndex: 111111111111"
                >{{ item.name }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col span="12">
            <a-form-item label="公司简称">
              <a-input
                placeholder="请输入公司简称"
                v-decorator="[
                  'shortname',
                  { rules: [{ required: true, message: '请填写公司简称' }] }
                ]"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col span="12">
            <a-form-item label="公司虚名">
              <a-input
                placeholder="请输入公司虚名"
                v-decorator="[
                  'fullname',
                  { rules: [{ required: true, message: '请填写公司虚名' }] }
                ]"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col span="12">
            <a-form-item label="所属行业">
              <a-cascader
                :options="jobs"
                :fieldNames="{
                  label: 'name',
                  value: 'id',
                  children: 'children'
                }"
                changeOnSelect
                expandTrigger="hover"
                style="marginTop: 3px; zIndex: 111111111111"
                placeholder="请选择所属行业"
                @click="getJobData"
                @change="onChangeJob"
                v-decorator="[
                  'Industry',
                  { rules: [{ required: true, message: '请设置所属行业' }] }
                ]"
              ></a-cascader>
            </a-form-item>
          </a-col>
          <a-col span="12">
            <a-form-item label="公司规模">
              <a-select
                v-decorator="[
                  'scale',
                  { rules: [{ required: true, message: '请设置公司规模' }] }
                ]"
                placeholder="请设置公司规模"
                style="width: 100%;marginTop: 3px"
              >
                <a-select-option
                  v-for="(item, index) in scales"
                  :key="index"
                  :value="item.value"
                >{{ item.name }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col span="12">
            <a-form-item label="融资阶段">
              <a-select
                v-decorator="[
                  'finance',
                  { rules: [{ required: true, message: '请设置融资阶段' }] }
                ]"
                placeholder="请设置融资阶段"
                style="width: 100%;marginTop: 3px"
              >
                <a-select-option
                  v-for="(item, index) in finances"
                  :key="index"
                  :value="item.value"
                >{{ item.name }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col span="12">
            <a-form-item label="公司所在地">
              <a-cascader
                changeOnSelect
                :options="options"
                :fieldNames="{
                  label: 'name',
                  value: 'id',
                  children: 'children'
                }"
                placeholder="请选择城市"
                style="marginTop:3px;"
                @click="getOptions"
                @change="onChangecity"
                v-decorator="[
                  'Adress',
                  { rules: [{ required: true, message: '请设置所属行业' }] }
                ]"
              ></a-cascader>
            </a-form-item>
          </a-col>
          <a-col span="12">
            <a-form-item label="公司主页">
              <a-input
                placeholder="请输入公司主页"
                v-decorator="[
                  'homepage',
                  { rules: [{ required: true, message: '请填写公司官网地址' }] }
                ]"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col span="12">
            <a-form-item label="公司logo">
              <a-upload
                :showUploadList="false"
                v-decorator="[
                  'picture',
                  { valuePropName: 'file', getValueFromEvent: normFile }
                ]"
                name="file"
                :action="uploadUrl"
                @change="handleUpload"
              >
                <div class="avatar">
                  <div class="upper">
                    <a-icon type="plus" />
                  </div>
                  <a-avatar :src="pictureUrl" alt size="large"></a-avatar>
                </div>
              </a-upload>
            </a-form-item>
          </a-col>
        </a-row>
        <h3>
          公司福利
          <span :style="{ color: '#35B5FE' }">
            (已选
            <span>{{ selectedTags.length }}</span>个)
          </span>
        </h3>
        <template v-for="tag in tags">
          <a-checkable-tag
            :key="tag"
            :checked="selectedTags.indexOf(tag) > -1"
            @change="checked => handleChange(tag, checked)"
          >{{ tag }}</a-checkable-tag>
        </template>
        <a-input
          v-if="inputVisible"
          ref="input"
          type="text"
          size="small"
          :style="{ width: '78px' }"
          :value="inputValue"
          @change="handleInputChange"
          @blur="handleInputConfirm"
          @keyup.enter="handleInputConfirm"
        />
        <a-tag @click="showInput" style="background: #fff; borderStyle: dashed;">
          <a-icon type="plus" />添加福利
        </a-tag>
        <h3 :style="{ marginTop: '20px' }">公司介绍</h3>
        <template>
          <a-textarea placeholder="请输入公司介绍" :rows="4" v-model="introduction" />
        </template>
      </a-spin>
    </a-form>
  </a-modal>
</template>

<script>
import Api from "@/api";
var timer;
const baseURL = process.env.VUE_APP_BASEURL;
export default {
  name: "EditMessage",
  props: ["getListData"],
  data() {
    return {
      form: this.$form.createForm(this),
      type: "",
      visible: false,
      checked1: false,
      checked2: false,
      checked3: false,
      tags: [],
      selectedTags: [],
      inputVisible: false,
      inputValue: "",
      uploadUrl: baseURL + "/common/file/upload",
      pictureUrl: "",
      logo: "",
      value: undefined,
      companyInfo: "",
      introduction: "",
      jobs: [],
      scales: [],
      finances: [],
      options: [],
      // adress: undefined,
      // dataIndustry: [],
      first_category_id: undefined,
      second_category_id: undefined,
      province_id: undefined,
      city_id: undefined,
      dist_id: undefined,
      dataCompany: [],
      post_id: undefined,
      loading: false
    };
  },
  created() {
    this.getOptions();
    this.getJobData();
  },
  mounted() {
    this.getAllData();
  },
  methods: {
    getSuggestApi(value) {
      Api.client.searchCompany({ keyword: value }).then(response => {
        if (response && response.list) {
          this.dataCompany = response.list;
        }
        console.log(this.dataCompany);
      });
    },
    debounce(fn, delay) {
      let self = this;
      timer && clearTimeout(timer);
      timer = setTimeout(() => {
        fn.apply(self);
      }, delay);
    },

    handleSearchC(value) {
      if (value.length >= 2) {
        this.debounce(() => this.getSuggestApi(value), 1000);
      }
    },
    async getOptions() {
      let response;
      try {
        response = await Api.common.getCityTree();
      } catch (e) {
        e.message.cached && (response = e.message.data);
      }
      this.options = response.tree;
    },
    onChangecity(value) {
      console.log(value);
      this.province_id = value[0];
      this.city_id = value[1];
      this.dist_id = value[2];
    },
    onChangeJob(value) {
      console.log(value);
      this.first_category_id = value[0];
      this.second_category_id = value[1];
    },
    async getAllData() {
      this.scales = undefined;
      this.loading = true;
      let res = await Api.common.getStaticValues();
      let response = [];
      let newArr = [];
      if (res.properties.company_scale) {
        this.loading = false;
        for (let key in res.properties.company_scale) {
          response.push(res.properties.company_scale[key]);
        }
        response.map((item, index) => {
          newArr.push({ name: `${item}`, value: `${index + 1}` });
        });
        this.scales = newArr;
      }
      let fresponse = [];
      let freArr = [];
      if (res.properties.company_finance_stage) {
        for (let key in res.properties.company_finance_stage) {
          fresponse.push(res.properties.company_finance_stage[key]);
        }
        fresponse.map((item, index) => {
          freArr.push({ name: `${item}`, value: `${index + 1}` });
        });
        this.finances = freArr;
      }
    },
    async getJobData() {
      this.jobs = undefined;
      let { tree: jobs } = await Api.common.getIndustryTree();
      this.jobs = jobs;
      console.log(this.jobs);
    },
    handleUpload(info) {
      if (info.file.status == "done") {
        this.pictureUrl = info.file.response.data.url;
        this.logo = info.file.response.data.key;
      }
    },
    normFile(e) {
      if (Array.isArray(e)) {
        return e;
      }
      return e && e.fileList;
    },
    save() {
      if (this.type === "edit") {
        console.log("编辑");
        this.form.validateFields((err, values) => {
          if (!err) {
            let params = {
              id: this.post_id,
              name: values.name,
              short_name: values.shortname,
              full_name: values.fullname,
              logo: this.logo,
              first_category_id: this.first_category_id,
              second_category_id: this.second_category_id,
              scale_id: values.scale, //公司规模
              financing_stage_id: values.finance, //融资阶段
              homepage: values.homepage,
              tags: this.selectedTags.length ? this.selectedTags.join(",") : '',
              introduction: this.introduction,
              province_id: this.province_id,
              city_id: this.city_id,
              dist_id: this.dist_id
            };
            console.log(params);
            Api.client.editCompany(params).then(res => {
              console.log(res);
              if (res) {
                this.$message.success("编辑");
                this.visible = false;
                this.getListData();
              } else {
                this.$message.error("添加失败");
              }
            });
          }
        });
      } else {
        console.log("添加");
        this.form.validateFields((err, values) => {
          if (!err) {
            let params = {
              name: values.name,
              short_name: values.shortname,
              full_name: values.fullname,
              logo: this.logo,
              first_category_id: this.first_category_id,
              second_category_id: this.second_category_id,
              scale_id: values.scale, //公司规模
              financing_stage_id: values.finance, //融资阶段
              homepage: values.homepage,
              tags: this.selectedTags.length ? this.selectedTags.join(",") : '',
              introduction: this.introduction,
              province_id: this.province_id,
              city_id: this.city_id,
              dist_id: this.dist_id
            };
            console.log(params);
            Api.client.addCompany(params).then(res => {
              console.log(res);
              if (res) {
                this.$message.success("添加成功");
                this.visible = false;
                this.getListData();
              } else {
                this.$message.error("添加失败");
              }
            });
          }
        });
      }
    },
    async show(item) {
      this.visible = true;
      if (item) {
        this.post_id = item.id;
        this.companyInfo = item;
      }
      if (this.type === "edit") {
        console.log("编辑");
        let arr1 = [];
        let arr2 = [];
        arr1.push(
          this.companyInfo.province_id,
          this.companyInfo.city_id,
          this.companyInfo.dist_id
        );
        arr2.push(
          this.companyInfo.first_category_id,
          this.companyInfo.second_category_id
        );
        this.$nextTick().then(() => {
          this.pictureUrl = this.companyInfo.logo_url;
          this.tags = this.companyInfo.tags_format;
          this.selectedTags = this.companyInfo.tags_format;
          this.introduction = this.companyInfo.introduction;
          this.first_category_id = this.companyInfo.first_category_id;
          this.second_category_id = this.companyInfo.second_category_id;
          this.province_id = this.companyInfo.province_id;
          this.city_id = this.companyInfo.city_id;
          this.dist_id = this.companyInfo.dist_id;
          setTimeout(() => {
            this.form.setFieldsValue({
              name: this.companyInfo.name,
              shortname: this.companyInfo.short_name,
              fullname: this.companyInfo.full_name,
              homepage: this.companyInfo.homepage,
              scale: this.companyInfo.scale_id,
              finance: this.companyInfo.financing_stage_id,
              Adress: arr1,
              Industry: arr2
            });
          }, 0);
        });
      } else {
        console.log("添加");
        this.form.resetFields();
        this.pictureUrl = "";
        this.selectedTags = "";
        this.introduction = "";
        let res = await Api.common.getStaticValues();
        console.log(res);
        this.tags = res.properties.tags;
      }
    },
    handleClose(removedTag) {
      const tags = this.tags.filter(tag => tag !== removedTag);
      console.log(tags);
      this.tags = tags;
    },

    showInput() {
      this.inputVisible = true;
      this.$nextTick(function() {
        this.$refs.input.focus();
      });
    },

    handleInputChange(e) {
      this.inputValue = e.target.value;
    },

    handleInputConfirm() {
      const inputValue = this.inputValue;
      let tags = this.tags;
      if (inputValue && tags.indexOf(inputValue) === -1) {
        tags = [...tags, inputValue];
      }
      console.log(tags);
      Object.assign(this, {
        tags,
        inputVisible: false,
        inputValue: ""
      });
    },
    handleChange(tag, checked) {
      const { selectedTags } = this;
      const nextSelectedTags = checked
        ? [...selectedTags, tag]
        : selectedTags.filter(t => t !== tag);
      console.log("You are interested in: ", nextSelectedTags.join(","));
      this.selectedTags = nextSelectedTags;
      console.log(this.selectedTags.join(","));
    },
    close() {
      this.visible = false;
      this.form.resetFields();
    }
  }
};
</script>

<style lang="scss">
.upper {
  margin-top: 30px;
  display: inline-block;
  margin-left: 20px;
  margin-right: 30px;
  width: 30px;
  height: 30px;
  .anticon {
    width: 100%;
    height: 100%;
    & > svg {
      width: 100%;
      height: 100%;
    }
  }
}
.ant-avatar-lg {
  display: inline-block;
  width: 100px;
  height: 100px;
  border-radius: 0;
}
</style>
